import { render, staticRenderFns } from "./Revisor.vue?vue&type=template&id=6dd267cc"
import script from "./Revisor.vue?vue&type=script&lang=js"
export * from "./Revisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports